import React from 'react'
import {FiPlusCircle, FiStar, FiStopCircle, FiPlayCircle} from 'react-icons/fi'
import {FaSpotify} from 'react-icons/fa'
import {MdCollectionsBookmark} from 'react-icons/md'
import {useNavigate} from 'react-router-dom'
import {useLoginPrompt} from '../hooks/useLoginPrompt'
import {useSpotifyAuth} from '../hooks/useSpotifyAuth'
import {getAuthUrl} from '../lib/spotify'
import styled from '../lib/styled-components'
import {Button, LinkButton} from './Button'
import {MergePlaylistModal} from './MergePlaylistModal'
import {NewPlaylistModal} from './NewPlaylistModal'

export const Wrapper = styled.div`
  display: flex;
  padding: 10px 40px;
  background-color: ${p => p.theme.colors.background};
  height: 50px;
  width: 100%;
  position: fixed;
  white-space: nowrap;
  overflow: auto;
  & button,
  a {
    margin-right: 10px;
  }
  z-index: 10;
  & *:last-child {
    margin-left: auto;
    margin-right: 0;
  }
  @media (width: ${p => p.theme.breakpoints.mobile}) {
    padding: 10px 10px;
  }
`

// const Avatar = styled.img``

export const Header = ({
  selected,
  resetSelected,
  logout
}: {
  selected?: string[]
  resetSelected?: () => void
  logout: () => void
}) => {
  const [auth] = useSpotifyAuth()
  const [openAddPrompt, AddPrompt, closeAddPrompt] = useLoginPrompt()
  const [openMergePrompt, MergePrompt, closeMergePrompt] = useLoginPrompt()
  const navigate = useNavigate()

  return (
    <Wrapper>
      <LinkButton
        icon={
          // TODO this doesn't work in FF, gets a weird width. RAGE
          // auth && auth.authenticated ? (
          //   <Avatar src={auth.user?.images?.[0].url} />
          // ) : (
          <FaSpotify />
          // )
        }
        to={`/`}
      >
        Playlists
      </LinkButton>

      {auth?.authenticated && auth.user.id && (
        <>
          <LinkButton icon={<FiStar />} to={`/collection/${auth.user.id}`}>
            Favorites
          </LinkButton>
          <LinkButton
            icon={<MdCollectionsBookmark />}
            to={`/playlists/${auth.user.id}`}
          >
            My Profile Playlists
          </LinkButton>
        </>
      )}
      <Button onClick={() => openAddPrompt()} icon={<FiPlusCircle />}>
        Submit
      </Button>
      {selected && selected.length > 1 && (
        <Button onClick={() => openMergePrompt()} icon={<FiPlusCircle />}>
          Merge Playlists
        </Button>
      )}
      <AddPrompt>
        <NewPlaylistModal
          onClose={closeAddPrompt}
          onAdd={id => {
            navigate(`/#${id}`)
          }}
        />
      </AddPrompt>
      {selected && selected.length > 1 && (
        <MergePrompt>
          {user => (
            <MergePlaylistModal
              onClose={() => {
                closeMergePrompt()
              }}
              onMerged={() => {
                if (resetSelected) {
                  resetSelected()
                }
                navigate(`/playlists/${user.id}`)
              }}
              selected={selected}
              userId={user.id}
            />
          )}
        </MergePrompt>
      )}
      {auth && auth?.authenticated ? (
        <>
          <Button onClick={logout} icon={<FiStopCircle />}>
            Logout
          </Button>
        </>
      ) : (
        <LinkButton to={getAuthUrl()} icon={<FiPlayCircle />}>
          Login
        </LinkButton>
      )}
    </Wrapper>
  )
}
